import { getServiceWrapper } from 'core/service-wrapper'
import { call, put, select } from 'redux-saga/effects'
import { updateFundAllocation } from 'quick-quote/product-investment/fund-allocation/utils'
import { getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'
import { getRiskEvaluated } from 'quick-quote/product-investment/risk-questionnaire/selectors'
import { calculateTotalAllocation } from 'core/service/investment'
import {
  updateLstuFundAllocation,
  updateLstuTotalFundAllocation,
} from 'quick-quote/product-investment/fund-allocation/lstu/actions'
import { getLstuFundAllocations } from 'quick-quote/product-investment/fund-allocation/lstu/selectors'

export function* onCalculateLstuTotalAllocationRequest(action) {
  const fundAllocations = yield select(getLstuFundAllocations)
  yield call(processAndUpdateLstuFundAllocation, updateFundAllocation(fundAllocations, action.payload))
}

export function* processAndUpdateLstuFundAllocation(fundAllocations) {
  const serviceWrapper = getServiceWrapper()
  const displayProductQuery = yield select(getSelectedDisplayProductQuery)
  const insuredRiskLevel = yield select(getRiskEvaluated)
  const allocationResult = yield call(
    calculateTotalAllocation,
    displayProductQuery,
    insuredRiskLevel.value,
    fundAllocations,
    serviceWrapper.products.INVESTMENT.getFundLimit
  )

  yield put(updateLstuFundAllocation(allocationResult.fundAllocations))
  yield put(updateLstuTotalFundAllocation(allocationResult.totalAllocation))
}
